/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { IconButton, SvgIcon, SvgIconProps, useTheme } from '@mui/material';
import { MouseEvent } from 'react';

function DisabledPowerIcon(props: Readonly<SvgIconProps>): React.JSX.Element {
    return (
        <SvgIcon {...props}>
            <PowerSettingsNewIcon />
            <line stroke="red" strokeWidth="2" x1="3" x2="21" y1="3" y2="21" />
        </SvgIcon>
    );
}

interface PowerButtonProps {
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
    size?: 'small' | 'large' | 'medium';
    visible: boolean;
}

export default function PowerButton({
    onClick,
    size = 'medium',
    visible,
    ...props
}: Readonly<PowerButtonProps & React.ComponentProps<typeof IconButton>>) {
    const theme = useTheme();

    const styles = {
        powerOff: {
            color: 'grey.500',
        },
        powerOn: {
            '&:hover': {
                backgroundColor: 'bgDark.main',
            },
            backgroundColor: 'primary.main',
            color: '#fff',
        },
    };

    return visible ? (
        <IconButton
            {...props}
            onClick={onClick}
            size={size}
            sx={[
                styles.powerOn,
                {
                    boxShadow: `0px 0px 5px 0px ${theme.palette.primary.main}`,
                    MozBoxShadow: `0px 0px 5px 0px ${theme.palette.primary.main}`,
                    WebkitBoxShadow: `0px 0px 5px 0px ${theme.palette.primary.main}`,
                },
                ...(props.sx ? (Array.isArray(props.sx) ? props.sx : [props.sx]) : []),
            ]}
        >
            <PowerSettingsNewIcon fontSize={size} />
        </IconButton>
    ) : (
        <IconButton
            {...props}
            onClick={onClick}
            size={size}
            sx={[
                styles.powerOff,
                {
                    boxShadow: `inset 0px 0px 3px 0px ${theme.palette.grey[500]}`,
                    MozBoxShadow: `inset 0px 0px 3px 0px ${theme.palette.grey[500]}`,
                    WebkitBoxShadow: `inset 0px 0px 3px 0px ${theme.palette.grey[500]}`,
                },
                ...(props.sx ? (Array.isArray(props.sx) ? props.sx : [props.sx]) : []),
            ]}
        >
            <DisabledPowerIcon fontSize={size} />
        </IconButton>
    );
}
